import { App } from "antd";
import { usePrev } from "hook/usePrev";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  orderBailiffAllSelector,
  orderBailiffOpenPaymentSelector,
} from "store/bailiff/payment/order/order_bailiff.selector";
//
//component
//redux
//selector
//actions
export const TriggerJobChange = ({ setPayment }) => {
  // -------------------------- VAR ----------------------------
  const { message, notification } = App?.useApp();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const open = useSelector(orderBailiffOpenPaymentSelector);
  const payment = useSelector(orderBailiffAllSelector);
  const status = payment?.status || null;
  const prevStatus = usePrev(status);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (prevStatus === null && status === "waiting" && open) {
      setPayment(payment);
    }
    if (prevStatus === "waiting" && status === null && open) {
      notification.success({
        message: "Thanh toán thành công!",
        description: "Hộp thoại sẽ tự động đóng sau ít phút",
        placement: "topRight",
        duration: 3,
      });

      notification.info({
        message: "File của bạn đang được xử lý",
        description:
          "Bạn sẽ nhận email thông báo ngay sau khi đơn hàng hoàn thành",
        placement: "topRight",
        duration: 5,
      });
    }
  }, [prevStatus, status, open, setPayment, payment, message, notification]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerJobChange;
